import { Directive, ElementRef, AfterViewInit, Renderer2, OnDestroy } from '@angular/core';

@Directive({
  selector: '[appAutoTooltip]'
})
export class AutoTooltipDirective implements AfterViewInit, OnDestroy {
  private resizeObserver?: ResizeObserver;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterViewInit() {
    this.checkAndAddTooltip();
    
    // Set up resize observer to recheck when content changes
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.checkAndAddTooltip();
      });
      this.resizeObserver.observe(this.el.nativeElement);
    }
  }

  ngOnDestroy() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  private checkAndAddTooltip() {
    const element = this.el.nativeElement;
    const isTextTruncated = element.scrollWidth > element.clientWidth;
    
    if (isTextTruncated) {
      const fullText = element.textContent?.trim() || element.innerText?.trim() || '';
      if (fullText) {
        this.renderer.setAttribute(element, 'matTooltip', fullText);
        this.renderer.setAttribute(element, 'matTooltipPosition', 'above');
        this.renderer.addClass(element, 'auto-tooltip-enabled');
      }
    } else {
      // Remove tooltip if text is not truncated
      this.renderer.removeAttribute(element, 'matTooltip');
      this.renderer.removeAttribute(element, 'matTooltipPosition');
      this.renderer.removeClass(element, 'auto-tooltip-enabled');
    }
  }
} 